export function disableInputOnRadioChange() {
	const fieldset = document.getElementById("contactUsLookingFor");
	const radioButtons = fieldset.querySelectorAll('input[type="radio"]');

	if (radioButtons.length > 0) {
		const inputsToDisable = fieldset.querySelectorAll(
			'textarea, input[type="checkbox"]',
		);

		radioButtons.forEach((radio) => {
			if (radio.checked) {
				disableInputs(inputsToDisable, radio);
			}

			radio.addEventListener("change", () => {
				disableInputs(inputsToDisable, radio);
			});
		});
	}

	function disableInputs(inputsToDisable, currentOption) {
		inputsToDisable.forEach((input) => {
			const radioSection = currentOption.parentElement.parentElement;
			const isThisRadioInput = radioSection.contains(input);

			isThisRadioInput
				? (input.disabled = false)
				: (input.disabled = true);
		});
	}
}
